"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const framer_motion_1 = require("framer-motion");
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const SuspenseContext_1 = require("../../contexts/SuspenseContext");
const helpers_1 = require("../../lib/helpers");
const Spinner_1 = __importDefault(require("../Animation/Spinner"));
const useAddToForwardRef_1 = require("../../hocs/useAddToForwardRef");
function getPageX(e) {
    if ('changedTouches' in e && e.changedTouches.length > 0) {
        return e.changedTouches[0].pageX;
    }
    if ('touches' in e && e.touches.length > 0) {
        return e.touches[0].pageX;
    }
    return e.pageX;
}
function getPageY(e) {
    if ('changedTouches' in e && e.changedTouches.length > 0) {
        return e.changedTouches[0].pageY;
    }
    if ('touches' in e && e.touches.length > 0) {
        return e.touches[0].pageY;
    }
    return e.pageY;
}
function clickedNearRefresher(e, refresherEle, initialDragY) {
    const pageX = getPageX(e);
    const { top: refresherEleTop, width: refresherEleWidth, left: refresherEleLeft } = refresherEle.getBoundingClientRect();
    const maxX = refresherEleLeft + refresherEleWidth;
    const minX = refresherEleLeft;
    const isTouchDevice = e.type.includes('touch');
    /* The ele doesnt have any height by default, so 50 is our assumed allowance. */
    const maxY = refresherEleTop + 100;
    const minY = refresherEleTop - 20;
    return pageX <= maxX && pageX >= minX && initialDragY <= maxY && initialDragY >= minY;
}
const SuspenseRefresher = (props) => {
    const { hook } = react_1.useContext(SuspenseContext_1.SuspenseContext);
    const { refresh: refreshFetcher, status } = hook;
    const initialDragYRef = react_1.useRef(0);
    const divRef = react_1.useRef(null);
    const [refreshing, setRefreshing] = react_1.useState(false);
    /* Because we dont want the div to have any height, we cant rely on callback props, we have to listen to all mouse events and determine it manually. */
    react_1.useEffect(() => {
        function onMouseDown(e) {
            const refresherEle = divRef.current;
            if (!refresherEle || refreshing) {
                return;
            }
            const initialDragY = getPageY(e);
            const draggedNearRefresher = clickedNearRefresher(e, refresherEle, initialDragY);
            if (draggedNearRefresher) {
                initialDragYRef.current = initialDragY;
            }
        }
        function onMouseMove(e) {
            const refresherEle = divRef.current;
            if (!refresherEle || initialDragYRef.current === 0 || refreshing) {
                return;
            }
            const pageY = getPageY(e);
            // we are swiping upwards
            if (pageY < initialDragYRef.current) {
                initialDragYRef.current = 0;
                return;
            }
            const dragLength = (pageY - initialDragYRef.current);
            const draggedNearRefresher = clickedNearRefresher(e, refresherEle, initialDragYRef.current);
            if (draggedNearRefresher) {
                e.preventDefault();
                e.stopPropagation();
            }
            if (initialDragYRef.current !== 0 && dragLength > 100 && status !== 'loading' && draggedNearRefresher) {
                setRefreshing(true);
                initialDragYRef.current = 0;
                refreshFetcher().then(() => {
                    setRefreshing(false);
                }).catch(() => {
                    setRefreshing(false);
                });
            }
        }
        const onMouseUp = () => {
            initialDragYRef.current = 0;
        };
        window.addEventListener('mousedown', onMouseDown);
        window.addEventListener('mouseup', onMouseUp);
        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('touchstart', onMouseDown);
        window.addEventListener('touchend', onMouseUp);
        window.addEventListener('touchmove', onMouseMove, { passive: false });
        return () => {
            window.removeEventListener('mousedown', onMouseDown);
            window.removeEventListener('mouseup', onMouseUp);
            window.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('touchstart', onMouseDown);
            window.removeEventListener('touchend', onMouseUp);
            window.removeEventListener('touchmove', onMouseMove);
        };
    }, [refreshFetcher, refreshing, status]);
    const ref = useAddToForwardRef_1.useAddToForwardRef(props, [divRef]);
    return (react_1.default.createElement("div", Object.assign({}, helpers_1.usePrimitiveProps(props), { ref: ref }),
        react_1.default.createElement(framer_motion_1.AnimatePresence, null, refreshing && (react_1.default.createElement(framer_motion_1.motion.div, { key: "refreshing", className: "j-suspense-refresh", initial: { height: 20 }, animate: { height: 84 }, exit: { height: 20 }, transition: { duration: 0.35 } },
            react_1.default.createElement(Spinner_1.default, null))))));
};
exports.default = withJourney_1.default('j-suspense-refresher', SuspenseRefresher);
